import styled, { css } from "styled-components"
import { Link } from "react-scroll"
import Img from "gatsby-image"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles
} from "../shared/typography.styles"
import { T } from "../../design-system/styles/typography"
import Breakpoints from "../shared/breakpoints"

export const Title = styled.div`
  ${T.sm.h3`500`};
  text-align: left;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3`500`}
    text-align: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3`500`}
    text-align: left;
  }

  ${props => props.styleModifier}
`

export const FadedTitleWrapper = styled.div`
  text-align: center;
  grid-column: 2 / 12;
  grid-row: 2;
  margin-top: 24px;
  
  @media(min-width: ${Breakpoints.md}) {
    grid-column:  6/ -1;
    margin-top: 128px;
    grid-row: 1;
  }

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
    margin-top: 208px;
    grid-column: 7 / -1;
  }
`

export const Orange = styled.span`
  color: var(--burnt-orange);
  font-weight: 500;
`

export const MediaContainer = styled.div`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: ${props => props.desktopCol};
  }
`

export const StyledFluid = styled(Img)`
  grid-column: 1 / -1;
  width: 100%;
  ${props => props.styleModifier}
`
export const StyledImg = styled.img`
  grid-column: 1 / -1;
  width: 100%;
  ${props => props.styleModifier}
`

export const titleStyle = css`
  grid-row: 2;
  margin-top: 24px;
  
  @media (min-width: ${Breakpoints.md}) {
    grid-row: 1;
    grid-column: 6 / -1;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;
  }
`

export const titleImageStyle = css`
  grid-row: 1;
  grid-column: 3 / 11;
  margin-top: 48px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 1 / 6;
    margin-top: 64px;
  }
`

export const locationDataStyle = css`
  grid-row: 4;
  margin-top: 32px;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-row: 3;
    margin-top: 48px;
    grid-column: 3 / 11;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-row: 2;  
    grid-column: 8 / -1;
    margin-top: 96px;
  }
`
export const VideoContainer = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  grid-row: 6;
  margin-top: 32px;
  margin-bottom: 24px;

  justify-self: center;
  align-self: center;
  overflow: hidden;
  width: 100vw;
  height: calc(100vw * 0.56);

  @media (min-width: ${Breakpoints.md}) {
    grid-row: 5;
    margin-top: 48px;
    margin-bottom: 32px;
    grid-column: 2 / -2;

    width: 59vw;
    max-width: 454px;
    height: calc(59vw * 0.56);
    max-height: 255px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
    grid-row: 3 / 5;
    margin-top: 144px;
    margin-bottom: 0px;
    width: 47vw;
    max-width: 680px;
    height: calc(47vw * 0.56);
    max-height: 382px;
  }

  & > * {
    width: 100% !important;
    height: 100% !important;
  }
`
export const syncIntStyle = css`
  grid-row: 9;
  margin-top: 32px;
  margin-bottom: 32px;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-row: 8;
    grid-column: 3 / -3;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -1;
    grid-row: 5 / 7;
    margin-top: 160px;
    margin-bottom: 120px;
    align-items: center;
  }
`

export const DetailsWrapper = styled.div`
  width: 100%;
  text-align: center;
  align-self: center;

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
  }

  ${props => props.styleModifier}
`

export const locationDetailsStyle = css`
  grid-column: 1 / -1;
  grid-row: 3;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-row: 2;
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
  }
`

export const mapGeoDetailsStyle = css`
  grid-column: 1 / -1;
  grid-row: 5;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    grid-row: 4;
    margin-top: 96px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -1;
    grid-row: 3;
    margin-top: 144px;
  }
`

export const syncIntDetailsStyle = css`
  grid-column: 1 / -1;
  grid-row: 8;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;  
    grid-row: 7;
    margin-top: 96px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 180px;
    grid-column: 2 / 7;
    grid-row: 5;  
  }
`

export const DetailsBody = styled.p`
  color: var(--body-text-grey);
  margin-top: 24px;
  ${mobileTextStyles.MobileBodyRegular}
  text-align: left;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletBodyRegular}
    text-align: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
    text-align: left;
  }
`

export const DemoLink = styled(Link)`
  cursor: pointer;
  ${desktopTextStyles.LinkText}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--burnt-orange);
  color: var(--white);
  width: 100%;
  margin-top: 32px;
  margin-bottom: 64px;
  justify-self: center;
  grid-column: 2 / -2;
  grid-row: 10;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 32px;
    grid-column: 4 / -4;
    max-width: 282px;
    grid-row: 9;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin: 96px 0px;
    grid-column: 2 / 4;
    grid-row: 5;
    max-height: 46px;
  }
`

export const videoProgressWrapperStyle = css`
  & > p {
    color: var(--slate);
  }

  & > img {
    margin-right: 24px;
  }

`